var MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Analysis = MDB.Mangl.Analysis || {}; 

(function ($) {
    $.extend(MDB.Mangl.Analysis, {
        initializeAudioPlayer: function (isReadOnly) {
            var player = $('#call-audio-player')
                , positionLastChanged = moment.utc()
                , position = player.data('position')
                , progressPercentage;


            player.closest('.box').sticky({topSpacing:50, zIndex: 1});

            player.on('position-changed', function (e, newPosition, newProgressPercentage) {
                position = newPosition;
                progressPercentage = newProgressPercentage;

                var now = moment.utc();

                //Post progress every 30 seconds
                if (Math.round(now.diff(positionLastChanged) / 1000) >= 30) {
                    positionLastChanged = now;
                    postProgress(false);
                }
            });

            MDB.createAudioPlayer(player);

            var old = window.onbeforeunload || $.noop;
            window.onbeforeunload = function () {
                postProgress(true);

                old.apply(this, arguments);
            }

            function postProgress(sync) {
                if (position === undefined || isReadOnly) {
                    return;
                }

                MDB.ajax({
                    url: player.data('update-progress-uri'),
                    data: {
                        audioProgress: Math.round(position),
                        audioProgressPercentage: Math.round(progressPercentage)
                    },
                    type: 'POST',
                    async: !sync
                });
            }
        }
    })
}(jQuery));